import React from "react";
import CarRegularSVG from "../Icons/CarRegularSVG";
import CarsSVG from "../Icons/CarsSVG";
import GavelLight from "../Icons/GavelLightSVG";
import ListOlSVG from "../Icons/ListOlSVG";

/* 
    The SectionIcon component we'll handle BNBN sale type and non BNBN sale type.
    The 'print all' pattern covers all bid now and all buy now sale type
    The 'print full' pattern covers non BNBN sale type
  */

const PrintMenuSectionIcon: React.FunctionComponent<{ title: string }> = ({
  title,
}) => (
  <>
    {title.includes("vehicle details") && (
      <CarRegularSVG
        width={18}
        height={18}
        display="inline-flex;"
        fill="#64798c"
      />
    )}
    {title.includes("sale section") && (
      <ListOlSVG width={18} height={18} display="inline-flex;" fill="#64798c" />
    )}
    {title.includes("print all") && (
      <CarsSVG width={20} height={20} display="inline-flex;" fill="#64798c" />
    )}
    {title.includes("print full") && (
      <GavelLight
        width={18}
        height={18}
        display="inline-flex;"
        fill="#64798c"
      />
    )}
  </>
);

export default PrintMenuSectionIcon;
